import React from 'react';
import { FiSmartphone, FiMonitor, FiTablet, FiHeadphones, FiCamera, FiTv, FiHardDrive, FiHome } from 'react-icons/fi';
import { IoGameControllerOutline, IoShirtOutline, IoFootstepsOutline } from 'react-icons/io5';

const iconMap = {
  smartphone: FiSmartphone,
  laptop: FiMonitor,
  tablet: FiTablet,
  headphones: FiHeadphones,
  'gamepad-2': IoGameControllerOutline,
  camera: FiCamera,
  tv: FiTv,
  usb: FiHardDrive,
  shirt: IoShirtOutline,
  footprints: IoFootstepsOutline,
  home: FiHome
};

const CategoryCard = ({ category, onClick, selected }) => {
  const Icon = iconMap[category.icon] || FiSmartphone;
  
  return (
    <button
      onClick={() => onClick(category)}
      className={`flex items-center gap-2 px-4 py-2 rounded-full transition-all whitespace-nowrap ${
        selected
          ? 'bg-[#DC143C] text-white shadow-lg'
          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
      }`}
    >
      <Icon className="text-lg" />
      <span className="text-sm font-medium">{category.name}</span>
    </button>
  );
};

export default CategoryCard;
